export default "__VITE_ASSET__DnpVYDjE__"